export const BIKE_SLOT = 'bike_slot';
